import { useEffect, useState, Fragment } from "react";
import { Combobox, Transition } from "@headlessui/react";

import { SelectorIcon, CheckIcon } from "@heroicons/react/outline";

import LoadingWheel from "../Shared/LoadingWheel";

import classNames from "../../utils/classNames";
import useAgencies from "../../data/useAgencies";

export default function MemberAddPartial({ currentMembers, handleAddGroup }) {
  const { agencies: allAgencies } = useAgencies();
  const [filteredAgencies, setFilteredAgencies] = useState();
  const [selectedAgencies, setSelectedAgencies] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (!allAgencies.isLoading) {
      let currentMemberIds = currentMembers.map((cg) => cg.id);

      let members = allAgencies.data.map((m) => {
        currentMemberIds.includes(m.id)
          ? (m.avaliable = false)
          : (m.avaliable = true);
        return m;
      });

      let filtered =
        searchTerm === ""
          ? members
          : members.filter((g) =>
              g.name.toLowerCase().includes(searchTerm.toLowerCase())
            );

      setFilteredAgencies(filtered);
    }
  }, [allAgencies.isLoading, allAgencies.data, searchTerm]);

  if (allAgencies.isLoading || !filteredAgencies) {
    return (
      <div className="flex items-center">
        <LoadingWheel width="w-8" height="h-8" />
      </div>
    );
  } else {
    return (
      <>
        <div className="block">
          <Combobox
            value={selectedAgencies}
            onChange={setSelectedAgencies}
            multiple
          >
            {({ open }) => (
              <>
                <Combobox.Label className="block text-sm font-medium text-gray-700">
                  Agencies
                </Combobox.Label>
                <div className="relative mt-1">
                  <Combobox.Input
                    className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 shadow-sm focus:border-etpink-500 focus:outline-none focus:ring-1 focus:ring-etpink-500 sm:text-sm"
                    onChange={(e) => setSearchTerm(e.target.value)}
                    displayValue={(agencies) =>
                      agencies.map((agency) => agency.name).join(", ")
                    }
                  />
                  <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                    <SelectorIcon
                      className="h-5 w-5 text-gray-400"
                      aria-hidden="true"
                    />
                  </Combobox.Button>
                  <Transition
                    show={open}
                    appear={true}
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Combobox.Options
                      static
                      className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
                    >
                      {filteredAgencies.length > 0 ? (
                        filteredAgencies.map((group) => (
                          <Combobox.Option
                            className={({ active }) =>
                              classNames(
                                active
                                  ? "text-white bg-etpink-600"
                                  : !group.avaliable
                                  ? "bg-gray-100 text-gray-400"
                                  : "text-gray-900",
                                "cursor-default select-none relative py-2 pl-8 pr-4"
                              )
                            }
                            key={group.id}
                            value={group}
                            disabled={!group.avaliable}
                          >
                            {({ active, selected }) => (
                              <>
                                <span
                                  className={classNames(
                                    "block truncate",
                                    selected && "font-semibold"
                                  )}
                                >
                                  {group.name}
                                </span>

                                {selected && (
                                  <span
                                    className={classNames(
                                      "absolute inset-y-0 left-0 flex items-center pl-1.5",
                                      active ? "text-white" : "text-etpink-600"
                                    )}
                                  >
                                    <CheckIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  </span>
                                )}
                              </>
                            )}
                          </Combobox.Option>
                        ))
                      ) : (
                        <Combobox.Option disabled className="cursor-default select-none relative py-2 text-center text-gray-500">
                            No agencies match the search terms
                        </Combobox.Option>
                      )}
                    </Combobox.Options>
                  </Transition>
                </div>
              </>
            )}
          </Combobox>
        </div>
        <div className="mt-8">
          <button
            type="button"
            onClick={() => handleAddGroup(selectedAgencies)}
            className="text-center w-full md:w-auto items-center px-3 py-2 mr-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-etpink-600 hover:bg-etpink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-etpink-500"
          >
            Add
          </button>
        </div>
      </>
    );
  }
}
